module.exports = __webpack_public_path__ + "static/media/folder.fe3fb103.svg";